<template>
  <g fill="none" stroke="#333333">
    <path d="M2 13 L9 3 L16 13" stroke="grey" />
    <path d="M2 14 a7.5 7.5 0 0 1 14 0" />
    <circle cx="1.5" cy="14" r="1" />
    <circle cx="16.5" cy="14" r="1" />
  </g>
</template>
